export const EMAIL_PLACEHOLDER = 'Enter your Hiver email';
export const LOG_IN_DESCRIPTION = 'Log in to access your Knowledge base';
export const LOG_IN = 'Log In';
export const WELCOME = 'Welcome!';
export const DIFF_EMAIL_ERROR = 'Please login using the same Google account';
export const NO_ACCESS_ERROR = 'You don’t have access to this section, please contact your administrator';
export const DEFAULT_LOGO = 'default';
export const LOGO_IMG = 'https://app.hiverkb.com/{{LOGO}}'
